import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Прокручивает страницу наверх при смене маршрута и к якорю, если он указан.
 * Глобальный `scroll-behavior: smooth` временно отключается, чтобы переход
 * не выглядел как прокрутка через весь документ.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const frame = requestAnimationFrame(() => {
        const target = document.getElementById(hash.slice(1));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return () => cancelAnimationFrame(frame);
    }

    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;

    return undefined;
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
